module.exports = "/_next/static/images/content-badge-tier-3-3df3a5c6419144cadfd21924445d6676.png";